export default __webpack_public_path__ + "static/media/BG.783f7047.svg";